import React from 'react';
import { useLocaleState, useTranslate } from 'react-admin';
import { Box, Typography, Paper } from '@mui/material';

/**
 * Kaynak dil bilgilendirme banner'ı — create ve edit formlarında paylaşılır.
 */
export const SourceLanguageBanner = ({ isEdit = false, record }) => {
  const [locale] = useLocaleState();
  const translate = useTranslate();

  const currentLangCode = isEdit ? record?.sourceLanguage || 'tr' : locale;
  const isTr = currentLangCode === 'tr';
  const isEn = currentLangCode === 'en';

  const flag = isTr ? '🇹🇷' : isEn ? '🇬🇧' : '🌐';
  const langName = isTr ? 'Türkçe' : isEn ? 'English' : currentLangCode.toUpperCase();

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        mb: 3,
        borderRadius: 3,
        background: 'linear-gradient(135deg, #EFF6FF 0%, #EEF2FF 100%)',
        border: '1.5px solid #BFDBFE',
      }}
    >
      <Box display="flex" alignItems="center" gap={2}>
        <Typography variant="h4" component="span">
          {flag}
        </Typography>
        <Box>
          <Typography variant="subtitle2" fontWeight={700} sx={{ color: '#1E3A8A' }}>
            {translate('form.source_language_title', 'Kaynak Dil:')}{' '}
            <span style={{ color: '#2563EB' }}>
              {langName} {isEdit ? '🔒 (Kilitli)' : ''}
            </span>
          </Typography>
          <Typography variant="caption" sx={{ color: '#1D4ED8', display: 'block', mt: 0.5 }}>
            {isEdit
              ? translate(
                  'form.source_language_locked_desc',
                  `Bu kaydın kaynak dili kilitlidir (${langName}). Güncellemeler esas alınarak diğer dillere DeepL ile otomatik çevrilecektir.`,
                  { lang: langName },
                )
              : translate(
                  'form.source_language_desc',
                  "İçerik bu dilde oluşturulacak ve diğer diller otomatik olarak DeepL ile çevrilecektir. Dili değiştirmek için navbar'daki dil seçeneğini kullanın.",
                )}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default SourceLanguageBanner;
